import React from 'react'
import { CFooter } from '@coreui/react' 
const TheFooter = () => {
  return (
    <CFooter  style={{backgroundColor:'white'}}  fixed={true}>
      {/*<div>*/}
      {/*  <a href="https://www.intelliscence.com/" target="_blank" rel="noopener noreferrer">Intelliscence</a>*/}
      {/*  <span className="ml-1"> Copyrights  &copy; Intelliscence 2020. All Rights Reserved</span> */}
      {/*</div>*/}
      {/*<div className="mfs-auto">*/}
      {/*  <img src={clogo} width="60px" height="40px" ></img>*/}
      
      {/*</div>*/}
    </CFooter>
  )
}

export default React.memo(TheFooter)
